const config = {
  apiGateways: {
    BASE_URL_1: process.env.REACT_APP_BACKEND_URL_HTTP
  },
  SOCKET_URL: process.env.REACT_APP_BACKEND_URL_WS,
  PIXI_ASSETS_BASE_URL: process.env.REACT_APP_PIXI_ASSETS_BASE_URL
}

export default config
